import api from '../token';

export const DeleteMoeda = async (dados) => {
  try {
    const response = await api.post('/deleteMoeda', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};